import React from 'react'
import {useInjection} from 'dna-react-ioc'
import {observer} from 'mobx-react'
import {Table} from 'antd'
import {PaginationContainer} from '@/components'
import {ITransactionsHistoryDataStore} from '@/pages/Overview'

export const PaymentsTransactionsHistoryDataStoreSymbol = Symbol('SettlementsTransactionsHistoryDataStore')
export const PaymentsTransactionsHistoryPaginationStoreSymbol = Symbol('SettlementsTransactionsHistoryPaginationStore')

export const PaymentsTransactionsHistoryTable = observer(() => {
    const {data} = useInjection<ITransactionsHistoryDataStore>(PaymentsTransactionsHistoryDataStoreSymbol)
    return (
       <>
        <Table
            dataSource={data}
            columns={[]}
            pagination={false}
        />
           <PaginationContainer
               injectableIdentifier={PaymentsTransactionsHistoryPaginationStoreSymbol}
           />
       </>
    )
})
